<template>
    <div>
        <div class="vx-row" v-if="this.report">
            <div class="vx-col w-full xl:w-1/6 lg:w-1/4 md:w-1/3">
                <vx-card :title="$t('Settings')" class="mb-3">
                    <p class="mt-6">{{$t("StartTime")}}</p>
                    <flat-pickr class="w-full" :config="configDateTimePicker" v-model="reportStartTime"></flat-pickr>
                    <p class="mt-6">{{$t("EndTime")}}</p>
                    <flat-pickr class="w-full" :config="configDateTimePicker" v-model="reportEndTime"></flat-pickr>
                    <vs-button class="mt-6" color="success" icon-pack="feather" icon="icon-edit" type="border" @click="updateReport">{{$t("Reload")}}</vs-button>
                </vx-card>
            </div>
            <div class="vx-col w-full xl:w-1/3 ls:w-1/2 md:w-1/2 mb-3">
                <vx-card :title="$t('Times')" collapse-action>

                    <!-- CHART -->
                    <div slot="no-body">
                        <vue-apex-charts type="radialBar" height="420" :options="timesChartOptions" :series="typesPercentageSeries" />
                    </div>

                    <ul>
                        <li class="flex mb-3 justify-between">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 border-3 border-solid d-theme-dark-bg" style="border-color: rgb(15,103,240)"></span>
                                    <span class="font-semibold">{{$t('Work')}}</span>
                            </span>
                            <span>{{report.total_work_time}}</span>
                        </li>

                        <li class="flex mb-3 justify-between">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 border-3 border-solid d-theme-dark-bg border-warning"></span>
                                    <span class="font-semibold">{{$t('Transport')}}</span>
                            </span>
                            <span>{{report.total_transport_time}}</span>
                        </li>

                        <li class="flex mb-3 justify-between">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 border-3 border-solid d-theme-dark-bg" style="border-color: #9b59b6"></span>
                                    <span class="font-semibold">{{$t('Meetings')}}</span>
                            </span>
                            <span>{{report.total_meetings_time}}</span>
                        </li>

                        <li class="flex mb-3 justify-between">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 border-3 border-solid d-theme-dark-bg border-danger"></span>
                                    <span class="font-semibold">{{$t('Absence')}}</span>
                            </span>
                            <span>{{report.total_vacation_time + report.total_sick_leave_time + report.total_parental_leave_time}}</span>
                        </li>
                        <li class="flex mb-3 justify-between">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 border-3 border-solid d-theme-dark-bg border-success"></span>
                                    <span class="font-semibold">{{$t('TimeEdits')}}</span>
                            </span>
                            <span>{{report.time_edits}}</span>
                        </li>
                    </ul>
                </vx-card>
            </div>
        </div>
        <div class="vx-row" v-if="this.report">
            <div v-if="timeList.length > 0" class="vx-col w-full mb-3">
                <vx-card :title="$t('Times')" collapse-action>
                    <vs-table ref="timesTable" :data="timeList" :max-items="itemsPerPageTimes" search pagination>

                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                        <span class="mr-2">{{ itemsPerPageTimes }}</span>
                                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                                    </div>

                                    <vs-dropdown-menu>

                                        <vs-dropdown-item @click="itemsPerPageTimes=10">
                                            <span>10</span>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item @click="itemsPerPageTimes=20">
                                            <span>20</span>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item @click="itemsPerPageTimes=50">
                                            <span>50</span>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item @click="itemsPerPageTimes=100">
                                            <span>100</span>
                                        </vs-dropdown-item>
                                    </vs-dropdown-menu>
                                </vs-dropdown>
                        </div>

                        <template slot="thead">
                            <vs-th sort-key="client_company">{{$t("Client")}}</vs-th>
                            <vs-th sort-key="task_name">{{$t("Title")}}</vs-th>
                            <vs-th sort-key="work_type">{{$t("WorkType")}}</vs-th>
                            <vs-th sort-key="end_time">{{$t("EndTime")}}</vs-th>
                            <vs-th sort-key="total_time">{{$t("TotalTime")}}</vs-th>
                            <vs-th></vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].client_company">
                                    {{data[indextr].client_company}}
                                </vs-td>
                                <vs-td :data="data[indextr].task_name">
                                    {{data[indextr].task_name}}
                                </vs-td>
                                <vs-td :data="data[indextr].work_type">
                                    {{data[indextr].work_type}}
                                </vs-td>

                                <vs-td :data="data[indextr].sub_times[0].start_time">
                                    {{moment(data[indextr].sub_times[data[indextr].sub_times.length-1].end_time).format('DD/MM/YYYY HH:mm')}}
                                </vs-td>

                                <vs-td :data="data[indextr].total_time">
                                    {{data[indextr].total_time}}
                                </vs-td>

                                <vs-td>
                                    <vs-button size="small" color="success" icon-pack="feather" icon="icon-eye" type="border" class="mr-3" @click="$router.push({ name: 'task', params: { id: data[indextr].task_id } })"></vs-button>
                                </vs-td>

                                <template slot="expand" >
                                    <vs-row vs-w="12">
                                        <vs-col vs-w="6" vs-sm="12" class="mt-6">
                                            <div class="mb-base" id="page-user-view">

                                                <table>
                                                    <tr>
                                                        <td class="font-semibold">{{$t("Notes")}}</td>
                                                    </tr>
                                                </table>
                                                <p style="white-space: pre-wrap">{{data[indextr].notes}}</p>

                                            </div>
                                        </vs-col>
                                        <vs-col vs-w="6" vs-sm="12" class="mt-6">
                                            <vs-table :data="data[indextr].sub_times">

                                                <template slot="thead">
                                                    <vs-th sort-key="start_time">{{$t("StartTime")}}</vs-th>
                                                    <vs-th sort-key="end_time">{{$t("EndTime")}}</vs-th>
                                                </template>

                                                <template slot-scope="{data}">
                                                    <vs-tr :data="tr1" :key="index1" v-for="(tr1, index1) in data">

                                                        <vs-td :data="data[index1].start_time">
                                                            {{ moment(data[index1].start_time).format('DD/MM/YYYY HH:mm') }}
                                                        </vs-td>

                                                        <vs-td :data="data[index1].end_time">
                                                            {{ moment(data[index1].end_time).format('DD/MM/YYYY HH:mm') }}
                                                        </vs-td>
                                                    </vs-tr>
                                                </template>
                                            </vs-table>
                                        </vs-col>
                                    </vs-row>
                                </template>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
        </div>


        <div class="vx-row" v-if="this.report">
            <div v-if="transportList.length > 0" class="vx-col w-full mb-3">
                <vx-card :title="$t('Transport')" collapse-action>
                    <vs-table ref="transportTable" :data="transportList" :max-items="itemsPerPageTransport" search pagination>

                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                    <span class="mr-2">{{ itemsPerPageTransport }}</span>
                                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                                </div>

                                <vs-dropdown-menu>

                                    <vs-dropdown-item @click="itemsPerPageTransport=10">
                                        <span>10</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPageTransport=20">
                                        <span>20</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPageTransport=50">
                                        <span>50</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPageTransport=100">
                                        <span>100</span>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>

                        <template slot="thead">
                            <vs-th>{{$t("StartTime")}}</vs-th>
                            <vs-th>{{$t("EndTime")}}</vs-th>
                            <vs-th>{{$t("StartPoint")}}</vs-th>
                            <vs-th>{{$t("Destination")}}</vs-th>
                            <vs-th>{{$t("Vehicle")}}</vs-th>
                            <vs-th>{{$t("Notes")}}</vs-th>
                            <vs-th>{{$t("TransportType")}}</vs-th>
                            <vs-th>{{$t("TotalTime")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].start_time">
                                    {{moment(data[indextr].start_time).format('DD/MM/YYYY HH:mm')}}
                                </vs-td>
                                <vs-td :data="data[indextr].end_time">
                                    {{moment(data[indextr].end_time).format('DD/MM/YYYY HH:mm')}}
                                </vs-td>

                                <vs-td :data="data[indextr].start_point">
                                    {{data[indextr].start_point}}
                                </vs-td>

                                <vs-td :data="data[indextr].end_point">
                                    {{data[indextr].end_point}}
                                </vs-td>

                                <vs-td :data="data[indextr].vehicle">
                                    {{data[indextr].vehicle}}
                                </vs-td>

                                <vs-td :data="data[indextr].notes">
                                    {{data[indextr].notes}}
                                </vs-td>

                                <vs-td :data="data[indextr].transport_type">
                                    {{data[indextr].transport_type}}
                                </vs-td>

                                <vs-td :data="data[indextr].total_time">
                                    {{data[indextr].total_time}}
                                </vs-td>

                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
        </div>
        <div class="vx-row" v-if="this.report">
            <div v-if="report.vacations.length > 0" class="vx-col w-full mb-3 xl:w-1/3 lg:w-1/3 md:w-1/2">
                <vx-card :title='$t("VacationDays")' collapse-action>
                    <vs-table :data="report.vacations">
                        <template slot="thead">
                            <vs-th>{{$t("StartTime")}}</vs-th>
                            <vs-th>{{$t("EndTime")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].start">
                                    {{moment(data[indextr].start).format('DD/MM/YYYY')}}
                                </vs-td>
                                <vs-td :data="data[indextr].end">
                                    {{moment(data[indextr].end).format('DD/MM/YYYY')}}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>

            <div v-if="report.absences.length > 0" class="vx-col w-full mb-3 xl:w-1/3 lg:w-1/3 md:w-1/2">
                <vx-card :title='$t("PlannedAbsence")' collapse-action>
                    <vs-table :data="report.absences">
                        <template slot="thead">
                            <vs-th>{{$t("StartTime")}}</vs-th>
                            <vs-th>{{$t("EndTime")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].start">
                                    {{moment(data[indextr].start).format('DD/MM/YYYY')}}
                                </vs-td>
                                <vs-td :data="data[indextr].end">
                                    {{moment(data[indextr].end).format('DD/MM/YYYY')}}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>

            <div v-if="report.sick_leaves.length > 0" class="vx-col w-full mb-3 xl:w-1/3 lg:w-1/3 md:w-1/2">
                <vx-card :title='$t("SickLeaves")' collapse-action>
                    <vs-table :data="report.sick_leaves">
                        <template slot="thead">
                            <vs-th>{{$t("StartTime")}}</vs-th>
                            <vs-th>{{$t("EndTime")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].start">
                                    {{moment(data[indextr].start).format('DD/MM/YYYY')}}
                                </vs-td>
                                <vs-td :data="data[indextr].end">
                                    {{moment(data[indextr].end).format('DD/MM/YYYY')}}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>

            <div v-if="report.parental_leaves.length > 0" class="vx-col w-full mb-3 xl:w-1/3 lg:w-1/3 md:w-1/2">
                <vx-card :title='$t("ParentalLeaves")' collapse-action>
                    <vs-table :data="report.parental_leaves">
                        <template slot="thead">
                            <vs-th>{{$t("StartTime")}}</vs-th>
                            <vs-th>{{$t("EndTime")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].start">
                                    {{moment(data[indextr].start).format('DD/MM/YYYY')}}
                                </vs-td>
                                <vs-td :data="data[indextr].end">
                                    {{moment(data[indextr].end).format('DD/MM/YYYY')}}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import VueApexCharts from 'vue-apexcharts'

    export default {
        components: {
            flatPickr,
            VueApexCharts
        },
        data() {
            return {

                itemsPerPageTimes: 10,
                isMounted: false,
                currentPageTimes: 1,

                itemsPerPageTransport: 10,
                currentPageTransport: 1,

                report: null,
                reportStartTime: null,
                reportEndTime: null,

                configDateTimePicker: {
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },


                timesChartOptions: {
                    labels: [this.$t('Work'), this.$t('Transport'), this.$t('Absence'), this.$t('Meetings')],
                    plotOptions: {
                        radialBar: {
                            size: 165,
                            offsetY: -5,
                            hollow: {
                                size: '25%'
                            },
                            track: {
                                background: "#ebebeb",
                                strokeWidth: '100%',
                                margin: 15,
                            },
                            dataLabels: {
                                show: true,
                                name: {
                                    fontSize: '18px',
                                },
                                value: {
                                    fontSize: '16px',
                                    color: "#636a71",
                                    offsetY: 11
                                },
                                total: {
                                    show: true,
                                    label: this.$t('Total'),
                                    formatter: this.getTotal,
                                }
                            }
                        },
                    },
                    responsive: [{
                        breakpoint: 576,
                        options: {
                            plotOptions: {
                                radialBar: {
                                    size: 150,
                                    hollow: {
                                        size: '20%'
                                    },
                                    track: {
                                        background: "#ebebeb",
                                        strokeWidth: '100%',
                                        margin: 15,
                                    },
                                }
                            }
                        }
                    }],
                    colors: ['#7961F9', '#FF9F43', '#EA5455', '#9b59b6'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            // enabled: true,
                            shade: 'dark',
                            type: 'vertical',
                            shadeIntensity: 0.5,
                            gradientToColors: ['#9c8cfc', '#FFC085', '#f29292', '#bb79d6'],
                            inverseColors: false,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100]
                        },
                    },
                    stroke: {
                        lineCap: 'round'
                    },
                    chart: {
                        height: 355,
                        dropShadow: {
                            enabled: true,
                            blur: 3,
                            left: 1,
                            top: 1,
                            opacity: 0.1
                        },
                    }
                }
            }
        },
        methods: {
            updateReport() {
                const thisIns = this;
                this.$http.post('/api/v1/profile/report', {
                    start_time: thisIns.moment(thisIns.reportStartTime).format(),
                    end_time: thisIns.moment(thisIns.reportEndTime).add(1, 'd').subtract(1, 'ms').format(),
                }).then(function (response) {
                    thisIns.report = response.data;
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            getTotal() {
                return this.report.total_time
            }
        },
        computed: {
            overviewPercentageSeries: function () {

                let data = [];

                if(this.report.needed_time) {
                    data.push(Number(this.report.done_percentage));
                }
                return data;
            },
            typesPercentageSeries: function () {

                let data = [];

                if(this.report) {
                    data.push(this.report.time_percentage);
                    data.push(this.report.transport_percentage);
                    data.push(this.report.absence_percentage);
                    data.push(this.report.meetings_percentage);

                    return data;
                }

                return [0,0,0,0];
            },
            timeList: function () {
                let list = [];
                if(this.report) {
                    for (let key in this.report.days){
                        if(this.report.days.hasOwnProperty(key)){
                            list.push(...this.report.days[key].times)
                        }
                    }
                }

                return list;
            },
            transportList: function () {
                let list = [];
                if(this.report) {
                    for (let key in this.report.days){
                        if(this.report.days.hasOwnProperty(key)){
                            list.push(...this.report.days[key].transports)
                        }
                    }
                }

                return list;
            }
        },
        mounted() {
            let currentTime = new Date();
            this.reportEndTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate());
            this.reportStartTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), 1);
            this.updateReport();
            this.isMounted = true;
        },
    }
</script>
<style lang="scss">
    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 140px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }
</style>
